module.exports = __webpack_public_path__ + "static/media/enterprise_pilot_plus_handshake.c071f6b7.svg";